export const delay = async (delayMs: number) => {
  await new Promise((resolve) => {
    setTimeout(resolve, delayMs)
  })
}
